<div class="bhub-demo-controls flex items-center gap-2">
  <span class="bhub-demo-controls__separator" aria-hidden="true"></span>
  <p-button
    icon="pi pi-chevron-left"
    [disabled]="!canStepBack()"
    (onClick)="onPrev()"
    [attr.aria-label]="backTooltip()"
    [pTooltip]="backTooltip()"
    tooltipPosition="bottom"
    [styleClass]="'p-button-text p-button-sm ' + (!canStepBack() ? 'bhub-demo-step-btn--muted' : '')"
  />
  <p-button
    icon="pi pi-chevron-right"
    [disabled]="!canStepForward()"
    (onClick)="onNext()"
    [attr.aria-label]="forwardTooltip()"
    [pTooltip]="forwardTooltip()"
    tooltipPosition="bottom"
    [styleClass]="'p-button-text p-button-sm ' + (!canStepForward() ? 'bhub-demo-step-btn--muted' : '')"
  />
  <button
    type="button"
    class="p-0 border-0 bg-transparent text-inherit cursor-pointer focus-visible:ring-2 focus-visible:ring-white rounded"
    aria-label="Demo settings"
    (click)="openSettings($event)"
  >
    <i class="pi pi-cog text-lg"></i>
  </button>
  <p-overlayPanel #settingsPanel (onHide)="showSettingsPanel.set(false)">
    <div class="flex flex-col gap-3 p-2 min-w-[240px]">

      <!-- Service status -->
      <div class="flex items-center gap-1.5 text-xs">
        @if (isAvailable()) {
          <span class="w-2 h-2 rounded-full bg-green-500 flex-shrink-0"></span>
          <span class="text-green-700 font-medium">StoryService connected</span>
        } @else {
          <span class="w-2 h-2 rounded-full bg-gray-400 flex-shrink-0"></span>
          <span class="text-gray-400">StoryService unavailable</span>
        }
      </div>

      <!-- Demo selector dropdown -->
      <div class="flex flex-col gap-1">
        <label class="text-xs font-semibold text-gray-600">Demo scenario</label>
        @if (availableDemos().length > 0) {
          <p-select
            [options]="availableDemos()"
            [ngModel]="demoId() || null"
            (ngModelChange)="onSelectDemo($event)"
            optionLabel="demoId"
            optionValue="demoId"
            placeholder="Default Template"
            styleClass="bhub-demo-select w-full"
            [showClear]="!!demoId()"
            [disabled]="!isAvailable()"
            aria-label="Select demo scenario"
          />
        } @else {
          <div class="text-xs text-gray-400 px-2 py-1 border border-gray-200 rounded">
            {{ isAvailable() ? 'No demos available' : 'Default Template' }}
          </div>
        }
      </div>

      @if (!isAvailable()) {
        <span class="text-xs text-gray-500">
          Story Service is unavailable. Controls are disabled.
        </span>
      }

      <!-- Step controls — only in story-demo mode -->
      @if (canUseStepActions()) {
        <div class="bhub-step-section">
          <label class="bhub-step-label">Current step</label>
          <div class="bhub-step-row">
            <div class="bhub-step-row__left">
              <!-- Inline step input -->
              <input
                type="number"
                min="1"
                [max]="maxStep() > 0 ? maxStep() : null"
                class="bhub-step-input"
                [value]="inlineStepInput()"
                (input)="inlineStepInput.set($any($event.target).valueAsNumber); inlineStepError.set(null)"
                (keydown.enter)="applyInlineStep()"
                [disabled]="!isAvailable()"
                aria-label="Current step number"
              />

              <!-- Submit (apply) -->
              <button
                type="button"
                class="bhub-step-icon-btn bhub-step-icon-btn--submit"
                [disabled]="!isAvailable() || !canApplyInlineStep()"
                (click)="applyInlineStep()"
                [attr.aria-label]="applyTooltip()"
                [pTooltip]="applyTooltip()"
                tooltipPosition="top"
              >
                <i class="pi pi-check"></i>
              </button>
            </div>

            <div class="bhub-step-row__right">
              <!-- Back -->
              <button
                type="button"
                class="bhub-step-icon-btn"
                [disabled]="!canStepBack()"
                (click)="onPrev()"
                [attr.aria-label]="backTooltip()"
                [pTooltip]="backTooltip()"
                tooltipPosition="top"
              >
                <i class="pi pi-angle-left"></i>
              </button>

              <!-- Forward -->
              <button
                type="button"
                class="bhub-step-icon-btn"
                [disabled]="!canStepForward()"
                (click)="onNext()"
                [attr.aria-label]="forwardTooltip()"
                [pTooltip]="forwardTooltip()"
                tooltipPosition="top"
              >
                <i class="pi pi-angle-right"></i>
              </button>

              <!-- Reset -->
              <button
                type="button"
                class="bhub-step-icon-btn"
                [disabled]="!canUseStepActions() || !isAvailable()"
                (click)="onReset()"
                [attr.aria-label]="resetTooltip()"
                [pTooltip]="resetTooltip()"
                tooltipPosition="top"
              >
                <i class="pi pi-refresh"></i>
              </button>
            </div>

          </div>

          <!-- Validation error -->
          @if (inlineStepError()) {
            <span class="bhub-step-error" role="alert">{{ inlineStepError() }}</span>
          }

          <!-- Recommended start step -->
          @if (recommendedStartStep() > 0) {
            <span class="bhub-step-hint">
              Recommended start: Step {{ recommendedStartStep() }}
            </span>
          }
          @if (isStepSyncPending()) {
            <span class="bhub-step-hint">Updating step…</span>
          }
          <span class="bhub-step-hint">
            Total steps: {{ totalStepsLabel() }}
          </span>
        </div>
      }

    </div>
  </p-overlayPanel>
</div>
